'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _reverse = require('./reverse');

var _reverse2 = _interopRequireDefault(_reverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var callR = (0, _reverse2.default)(_call2.default, _INT_TWO2.default); /**
                                                                        * Invoke a function without arguments
                                                                        *
                                                                        * @module invoke
                                                                        * @func
                                                                        * @since 1.18.0
                                                                        * @param {function} fn
                                                                        * @return {*}
                                                                        * @example
                                                                        *
                                                                        *     var foo = () => 1;
                                                                        *     invoke(foo); //=> 1;
                                                                        */

var invoke = callR([]);

exports.default = invoke;